const projectName = import.meta.env.VITE_GLOB_APP_TITLE

export function warn(message: string) {
  console.warn(`[${projectName} warn]:${message}`)
}

export function error(message: string) {
  throw new Error(`[${projectName} error]:${message}`)
}

export function logVersion(bool = false) {
  if (!bool) return
  console.groupCollapsed(`${projectName} version`)
  console.log(`lastBuildTime: ${__APP_INFO__.lastBuildTime}`)
  console.log(`lastCommitInfo: ${__GIT_INFO__.lastCommitInfo}`)
  console.log(`commit: ${__GIT_INFO__.commitHash}`)
  console.log(`tag: ${__GIT_INFO__.tag}`)
  console.groupEnd()
}
